import { Link } from 'react-router-dom';

function Button(props) {
	const { type, id, className, title, style, onClick, disabled, href, download, target, tabIndex, children } = props;

	if (href) {
		return (
			<a
				className={className ? `gs-btn ${className}` : 'gs-btn'}
				onClick={onClick}
				disabled={disabled}
				href={href}
				target={target}
				rel={target === '_blank' ? 'noopener noreferrer' : null}
				title={target === '_blank' ? '새창 열림' : null}
				style={style}
				download={download ? download : false}
			>
				{children}
			</a>
		);
	}
	return (
		<button
			id={id}
			type={type ? type : 'submit'}
			className={className ? `gs-btn ${className}` : `gs-btn`}
			title={title}
			style={style}
			tabIndex={tabIndex}
			onClick={onClick}
			disabled={disabled}
		>
			{children}
		</button>
	);
}

function PageControlBtns(props) {
	const { className, listUrl, isBtn = false, onClick = () => {}, children } = props;

	return (
		<div className={`gs-page-control-btns ${className ? className : ''}`}>
			<div>
				{children &&
					<div className="pcb-1">
						{children}
					</div>
				}
				{listUrl && (
					<div className="pcb-2">
						<Link to={listUrl} className="gs-btn white go-to-list">
							목록으로
						</Link>
					</div>
				)}
				{isBtn && (
					<div className="pcb-2">
						<Button onClick={onClick} className="gs-btn white go-to-list">
							목록으로
						</Button>
					</div>
				)}
			</div>
		</div>
	);
}

export { Button, PageControlBtns };
